// Customer-portal i18n only (NO/EN). Admin/Service/Vask portals stay in Norwegian.
const dict = {
  no: {
    portal_title: "Min booking",
    welcome: "Velkommen",
    your_boat: "Din båt",
    booking_period: "Periode",
    checkin_label: "Innsjekk",
    checkout_label: "Utsjekk",
    checkin_time: "fra kl. 14:00",
    checkout_time: "innen kl. 10:00",
    times_note: "Husk: innsjekk fra kl. 14:00 og utsjekk innen kl. 10:00.",
    guests: "Antall personer",
    update_guests: "Oppdater antall",
    save: "Lagre",
    saving: "Lagrer…",
    report_title: "Rapportér skade / feil / glemt gjenstand",
    report_subject: "Tittel",
    report_description: "Beskrivelse",
    add_photo: "Legg ved bilde",
    submit_report: "Send rapport",
    no_booking: "Ingen aktiv booking funnet på din konto.",
    logout: "Logg ut",
    language: "Språk",
    no_boat: "Ingen båt tildelt enda",
    customer_reports: "Dine rapporter",
    submitted: "Sendt",
    status: "Status",
    eco_slogan: "Eco-Friendly Boat Rental in Telemark",
    report_sent: "Takk! Rapporten er sendt til vårt team.",
    guests_saved: "Antall personer er oppdatert. Vi klargjør båten for dere.",
    open: "Åpen",
    in_progress: "Under arbeid",
    resolved: "Løst",
    welcome_aboard: "Velkommen ombord!",
    welcome_aboard_body: "Vi gleder oss til å ta vare på deg og dine på Telemarkskanalen. Her finner du all info om bookingen din, dokumenter til turen og direkte kontakt med teamet vårt.",
    welcome_dismiss: "Lukk hilsen",
    documents_title: "Dokumenter til din tur",
    documents_empty: "Ingen dokumenter er delt med deg ennå – de vil dukke opp her når de er klare.",
    documents_global: "Generell info",
    documents_booking: "Til denne bookingen",
    open_doc: "Åpne",
    extras_title: "Tilleggstjenester",
    extras_subtitle: "Gjør oppholdet litt ekstra. Legg til det du ønsker — admin klargjør ved ankomst.",
    extras_recommended: "Anbefalt",
    extras_per_day: "per dag",
    extras_per_booking: "for hele bookingen",
    extras_purchase: "kjøp",
    extras_quantity: "Antall",
    extras_add: "Legg til",
    extras_order_now: "Bestill",
    extras_pay_now: "Betal nå",
    extras_pay_on_arrival: "Betal ved ankomst",
    extras_total: "Sum",
    extras_subtotal: "Sub-total",
    extras_cart_empty: "Ingen tilleggstjenester valgt ennå.",
    extras_remove: "Fjern",
    extras_cancel: "Avbryt bestilling",
    extras_order_placed: "Bestilling sendt. Du får bekreftelse fra teamet.",
    extras_order_cancelled: "Bestillingen er avbrutt.",
    account_title: "Min konto",
    account_arrival_due: "Betales ved ankomst",
    account_arrival_paid: "Betalt",
    account_arrival_unpaid: "Ikke betalt enda",
    account_orders_outstanding: "Utestående tilleggsbestillinger",
    account_orders_paid: "Betalte tilleggsbestillinger",
    account_included_title: "Inkludert i din booking",
    account_included_subtitle: "Disse produktene er forhåndsbetalt og klare når du kommer.",
    account_total_outstanding: "Total utestående",
    account_pay_button: "Betal nå",
    account_pay_disabled_note: "Stripe-betaling aktiveres når nøkkelen er på plass. Inntil videre kan du betale ved innsjekk eller utsjekk.",
    account_pay_at_checkin: "Betaling skjer ved inn- eller utsjekk (kort/kontant).",
    lifevests_title: "Flytevester ombord",
    lifevests_total: "Totalt",
    lifevests_count_unit: "stk",
    lifevests_empty: "Vi legger inn oversikten før ankomst.",
    order_status_pending: "Venter",
    order_status_paid: "Betalt",
    order_status_cancelled: "Avbrutt",
    survey_title: "Hvordan var turen?",
    survey_intro: "Gi oss tilbakemelding med terningkast (1-6). Du får 10 % rabatt på neste booking som takk – gyldig i 3 måneder.",
    survey_q_boat: "Hvor fornøyd var du med båten generelt?",
    survey_q_crew: "Hvor fornøyd var du med servicen fra crew?",
    survey_q_followup: "Hvor fornøyd var du med oppfølging?",
    survey_q_equipment: "Hvor fornøyd var du med utstyret ombord?",
    survey_q_improve: "Hva kunne vært bedre?",
    survey_q_suggest: "Hva kunne du ønske at vi gjorde annerledes?",
    survey_q_nps: "Hvor sannsynlig er det at du anbefaler Canal Boats til andre? (0-10)",
    survey_anonymous: "Svar anonymt",
    survey_submit: "Send inn undersøkelse",
    survey_skip: "Send inn uten å svare",
    survey_done_title: "Takk for tilbakemeldingen!",
    survey_done_body: "Vi setter stor pris på at du tok deg tid.",
    survey_voucher_title: "Din rabattkode",
    survey_voucher_body: "Bruk koden på din neste booking. Gyldig i 3 måneder.",
    survey_skipped_note: "Undersøkelsen ble hoppet over – ingen rabattkode utstedt.",
    survey_locked: "Undersøkelsen åpnes etter at turen er ferdig.",
    // Incidents / skadesak – customer facing
    incidents_title_customer: "Mine skadesaker",
    incidents_subtitle_customer: "Her finner du dine aktive saker fra Canal Boats Telemark.",
    incidents_search_placeholder: "Søk på ref eller tittel…",
    incidents_status_filter_all: "Alle statuser",
    incidents_loading: "Laster…",
    incidents_empty_title: "Ingen saker",
    incidents_empty_body_customer: "Det er ikke registrert noen sak på deg.",
    incident_back_to_list: "Alle saker",
    incident_not_found: "Fant ikke saken.",
    incident_go_to_list: "Til oversikt",
    incident_created: "Opprettet",
    incident_resolved_at: "Løst",
    incident_closed_at: "Lukket",
    incident_insurance_title: "Forsikringsinformasjon",
    incident_insurance_company: "Selskap",
    incident_insurance_ref: "Sak-/skade-nr.",
    incident_insurance_not_set: "Ikke registrert",
    incident_attachments_title: "Vedlegg",
    incident_attachment_from_customer: "Fra deg",
    incident_attachment_from_company: "Fra Canal Boats",
    incident_attachment_download: "Last ned",
    incident_messages_title: "Meldinger",
    incident_messages_empty: "Ingen meldinger enda.",
    incident_composer_label: "Skriv en melding",
    incident_composer_placeholder_customer: "Skriv til Canal Boats. Beskriv gjerne så detaljert som mulig.",
    incident_composer_attach: "Legg ved bilde/dokument",
    incident_composer_uploading: "Laster opp…",
    incident_composer_send: "Send",
    incident_composer_sending: "Sender…",
    incident_closed_notice: "Denne saken er lukket. Ta kontakt med Canal Boats om noe må gjenåpnes.",
    incident_log_kind_phone_call: "Telefon",
    incident_log_kind_email: "E-post",
    incident_log_kind_meeting: "Møte",
    incident_log_kind_note: "Notat",
    incident_log_kind_message: "Melding",
    incident_log_logged_by: "Loggført av",
    incident_customer_you: "Deg",
    incident_customer_team: "Canal Boats",
    incident_log_incoming: "Innkommende",
    incident_log_outgoing: "Utgående",
  },
  en: {
    portal_title: "My booking",
    welcome: "Welcome",
    your_boat: "Your boat",
    booking_period: "Period",
    checkin_label: "Check-in",
    checkout_label: "Check-out",
    checkin_time: "from 2:00 PM",
    checkout_time: "by 10:00 AM",
    times_note: "Remember: check-in from 2:00 PM and check-out by 10:00 AM.",
    guests: "Number of guests",
    update_guests: "Update guests",
    save: "Save",
    saving: "Saving…",
    report_title: "Report damage / fault / forgotten item",
    report_subject: "Subject",
    report_description: "Description",
    add_photo: "Attach photo",
    submit_report: "Send report",
    no_booking: "No active booking found on your account.",
    logout: "Log out",
    language: "Language",
    no_boat: "No boat assigned yet",
    customer_reports: "Your reports",
    submitted: "Submitted",
    status: "Status",
    eco_slogan: "Eco-Friendly Boat Rental in Telemark",
    report_sent: "Thank you! Your report has been sent to our team.",
    guests_saved: "Guest count updated. We will prepare the boat accordingly.",
    open: "Open",
    in_progress: "In progress",
    resolved: "Resolved",
    welcome_aboard: "Welcome aboard!",
    welcome_aboard_body: "We're thrilled to host you on the Telemark canal. Here you'll find your booking details, all documents for your trip, and a direct line to our team.",
    welcome_dismiss: "Dismiss",
    documents_title: "Documents for your trip",
    documents_empty: "No documents have been shared with you yet – they'll appear here as soon as they're ready.",
    documents_global: "General info",
    documents_booking: "For this booking",
    open_doc: "Open",
    extras_title: "Add-ons & extras",
    extras_subtitle: "Make your trip a little extra. Add what you'd like — our team will prepare it before arrival.",
    extras_recommended: "Recommended",
    extras_per_day: "per day",
    extras_per_booking: "for the whole booking",
    extras_purchase: "purchase",
    extras_quantity: "Qty",
    extras_add: "Add",
    extras_order_now: "Place order",
    extras_pay_now: "Pay now",
    extras_pay_on_arrival: "Pay on arrival",
    extras_total: "Total",
    extras_subtotal: "Subtotal",
    extras_cart_empty: "No add-ons selected yet.",
    extras_remove: "Remove",
    extras_cancel: "Cancel order",
    extras_order_placed: "Order received. You'll get a confirmation from our team.",
    extras_order_cancelled: "Order cancelled.",
    account_title: "My account",
    account_arrival_due: "Due on arrival",
    account_arrival_paid: "Paid",
    account_arrival_unpaid: "Not paid yet",
    account_orders_outstanding: "Outstanding add-on orders",
    account_orders_paid: "Paid add-on orders",
    account_included_title: "Included in your booking",
    account_included_subtitle: "These items are prepaid and ready when you arrive.",
    account_total_outstanding: "Total outstanding",
    account_pay_button: "Pay now",
    account_pay_disabled_note: "Online payment opens up as soon as our Stripe key is in place. For now you'll settle the bill at check-in or check-out.",
    account_pay_at_checkin: "Payment is collected at check-in or check-out (card/cash).",
    lifevests_title: "Life vests on board",
    lifevests_total: "Total",
    lifevests_count_unit: "pcs",
    lifevests_empty: "We'll add this overview before you arrive.",
    order_status_pending: "Pending",
    order_status_paid: "Paid",
    order_status_cancelled: "Cancelled",
    survey_title: "How was your trip?",
    survey_intro: "Rate your experience (1-6 dice). Get 10% off your next booking as a thank-you – valid for 3 months.",
    survey_q_boat: "How happy were you with the boat overall?",
    survey_q_crew: "How happy were you with the crew's service?",
    survey_q_followup: "How happy were you with follow-up?",
    survey_q_equipment: "How happy were you with the on-board equipment?",
    survey_q_improve: "What could have been better?",
    survey_q_suggest: "What would you like us to do differently?",
    survey_q_nps: "How likely are you to recommend Canal Boats to others? (0-10)",
    survey_anonymous: "Reply anonymously",
    survey_submit: "Submit survey",
    survey_skip: "Submit without answering",
    survey_done_title: "Thanks for your feedback!",
    survey_done_body: "We really appreciate you taking the time.",
    survey_voucher_title: "Your discount code",
    survey_voucher_body: "Use this code on your next booking. Valid for 3 months.",
    survey_skipped_note: "Survey was skipped – no discount code issued.",
    survey_locked: "The survey opens after your trip ends.",
    // Incidents / cases – customer facing
    incidents_title_customer: "My cases",
    incidents_subtitle_customer: "Your open cases with Canal Boats Telemark.",
    incidents_search_placeholder: "Search by ref or title…",
    incidents_status_filter_all: "All statuses",
    incidents_loading: "Loading…",
    incidents_empty_title: "No cases",
    incidents_empty_body_customer: "You have no registered cases.",
    incident_back_to_list: "All cases",
    incident_not_found: "Case not found.",
    incident_go_to_list: "Back to list",
    incident_created: "Created",
    incident_resolved_at: "Resolved",
    incident_closed_at: "Closed",
    incident_insurance_title: "Insurance information",
    incident_insurance_company: "Company",
    incident_insurance_ref: "Case / claim no.",
    incident_insurance_not_set: "Not registered",
    incident_attachments_title: "Attachments",
    incident_attachment_from_customer: "From you",
    incident_attachment_from_company: "From Canal Boats",
    incident_attachment_download: "Download",
    incident_messages_title: "Messages",
    incident_messages_empty: "No messages yet.",
    incident_composer_label: "Write a message",
    incident_composer_placeholder_customer: "Write to Canal Boats. Please describe things in as much detail as you can.",
    incident_composer_attach: "Attach photo/document",
    incident_composer_uploading: "Uploading…",
    incident_composer_send: "Send",
    incident_composer_sending: "Sending…",
    incident_closed_notice: "This case is closed. Contact Canal Boats if it needs to be re-opened.",
    incident_log_kind_phone_call: "Phone call",
    incident_log_kind_email: "Email",
    incident_log_kind_meeting: "Meeting",
    incident_log_kind_note: "Note",
    incident_log_kind_message: "Message",
    incident_log_logged_by: "Logged by",
    incident_customer_you: "You",
    incident_customer_team: "Canal Boats",
    incident_log_incoming: "Incoming",
    incident_log_outgoing: "Outgoing",
  },
};

export function t(lang, key) {
  return (dict[lang] && dict[lang][key]) || dict.en[key] || key;
}

export function checklistLabel(item, lang) {
  return lang === "en" ? item.label_en : item.label_no;
}

export function productName(p, lang) {
  return (lang === "en" ? p.name_en : p.name_no) || p.name_no;
}

export function productDescription(p, lang) {
  return (lang === "en" ? p.description_en : p.description_no) || p.description_no || "";
}
